import React from 'react'
import PropTypes from 'prop-types'
import { default as ReactSelect } from 'react-select'
import { components } from 'react-select'
import makeAnimated from 'react-select/lib/animated'
import _ from 'lodash'

const animatedComponents = makeAnimated()

const Option = props => {
  return (
    <div>
      <components.Option {...props}>
        <div className="pretty p-default">
          {/* <input type="checkbox" checked={props.isSelected} onChange={() => null} /> */}
          <div className="state p-success">
            <label>{_.startCase(props.label)}</label>
          </div>
        </div>
      </components.Option>
    </div>
  )
}

const MultiValue = props => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
)

const ExtendedMultiSelect = props => {
  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        components={{ Option, MultiValue, animatedComponents, ...props.components }}
        options={[props.allOption, ...props.options]}
        onChange={(selected, event) => {
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === props.allOption.value) {
              return props.onChange([props.allOption, ...props.options])
            }
            let result = []
            if (selected.length === props.options.length) {
              if (selected.includes(props.allOption)) {
                result = selected.filter(option => option.value !== props.allOption.value)
              } else if (event.action === 'select-option') {
                result = [props.allOption, ...props.options]
              }
              return props.onChange(result)
            }
          }

          return props.onChange(selected)
        }}
      />
    )
  }

  return <ReactSelect {...props} />
}

ExtendedMultiSelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
}

ExtendedMultiSelect.defaultProps = {
  allOption: {
    label: 'انتخاب همه',
    value: '*',
  },
}

export default ExtendedMultiSelect